module.exports = __webpack_public_path__ + "static/media/Artboard8.03e7f3a1.svg";